import React from 'react'
import styles from './styles.css'

export default function DashedLabel({children}) {
  return <div className={styles.container}>{children}</div>
}



// WEBPACK FOOTER //
// ./src/App/components/DashedLabel/index.js